import React, { useState } from 'react'
import { router, usePage } from '@inertiajs/react'
import Box from '@mui/material/Box'
import { AppLayout } from '@/components/layouts/AppLayout'
import { BoardWizardDialog } from '@/components/tasks/BoardWizardDialog'

interface ProjectRef {
  id: number
  name: string
}

interface Props {
  projects: ProjectRef[]
}

export default function New({ projects }: Props) {
  const { current_agent } = usePage().props as { current_agent?: { id: number } }
  const [open, setOpen] = useState(true)

  function handleClose() {
    setOpen(false)
    router.visit('/tasks/all')
  }

  return (
    <AppLayout title="New board">
      <Box />
      <BoardWizardDialog
        open={open}
        onClose={handleClose}
        projects={projects}
        currentAgentId={current_agent?.id ?? 0}
        submitUrl="/tasks/boards"
      />
    </AppLayout>
  )
}
